import React, { useState } from "react";
import Layout from "../../../../HOC/layout/Layout";
import SecondaryHeader from "../../../UI/SecondaryHeader/SecondaryHeader";
import Table from "../../../UI/Table/Table";
import ReusableFilterDateAndName from "../../ReusableFilter/ReusableFilterDateAndName";
const Thead = [
  { title: "s.nO", with: "20%" },
  { title: "name", with: "20%" },
  { title: "date", with: "20%" },
];
const Tbody = [
  { name: "apple", createdAt: "2022/11/05" },
  { name: "banana", createdAt: "2022/11/05" },
  { name: "strawberry", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
  { name: "pineapple", createdAt: "2022/11/05" },
];

const TotalPrice = () => {
  let price = 0;

  Tbody.map((val, i) => {
    price += Number(val.price);
  });
  return price;
};

function AttendenceTable() {
  const [Tody, setTody] = useState([]);
  const SearchText = () => {
    // alert(4);
    console.log(4);
  };
  return (
    <Layout>
      <div className="mx-4">
        <ReusableFilterDateAndName />
        {Tbody.length > 0 ? (
          <div className="mt-2 mb-2  w-11/12 mx-auto tablet:w-full tablet:mx-0">
            <Table Head={Thead} height="attendence">
              {Tbody.map((val, i) => {
                return (
                  <tr key={i}>
                    <td align="center">
                      <div className="border-b p-2.5 border-gray-300">
                        {i + 1}
                      </div>
                    </td>
                    <td align="center">
                      <div className="border-b p-2.5 capitalize border-gray-300">
                        {val.name}
                      </div>
                    </td>
                    <td align="center">
                      <div className="border-b p-2.5 border-gray-300">
                        {val.createdAt}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </Table>
          </div>
        ) : (
          <div className="">
            <Table Head={Thead}></Table>
            <div className="text-2xl flex   justify-center items-center  h-96">
              No table data available yet!
            </div>
          </div>
        )}
        {/* <div className="capitalize font-semibold text-lg laptop:px-9  border-b w-11/12 laptop:w-full flex  items-center  py-1 justify-end  ">
        <div className="text-gray-700">total price= </div>
        <div className="text-gray-800"> rs{TotalPrice()}</div>
      </div>
      <form className="laptop:flex  mt-7 justify-center ">
        <div className="capitalize   w-11/12 laptop:w-full laptop:mr-4 flex justify-end  my-2">
          <div className="w-fit   flex  items-center gap-1.5">
            <div className="text-gray-500 font-semibold ">discount price= </div>
            <input
              type="text"
              placeholder="Discount Amount"
              className="border bg-sky-50 my-0.5 w-48  px-2 py-0.5"
            />
          </div>
        </div>

        <div className="capitalize  w-11/12 laptop:w-full laptop:ml-4 flex justify-end my-2 ">
          <div className="w-fit  flex items-center gap-1.5">
            <div className="text-gray-500 font-semibold ">VAT = </div>
            <div className="text-gray-700">
              <input
                type="text"
                placeholder="VAT Amount"
                className="border bg-sky-50 my-0.5  px-2 py-0.5 w-48"
              />
            </div>
          </div>
        </div>
      </form>
      <div className="capitalize font-semibold   flex justify-end w-11/12 my-5 ">
        <div className="border-b w-fit  flex gap-1.5">
          <div className="text-gray-500">total amount = </div>
          <div className="text-gray-700"> rs.60</div>
        </div>
      </div>
      <div className="flex justify-end  w-11/12">
        <button className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 ">
          proceed to pay
        </button>
      </div> */}
      </div>
    </Layout>
  );
}

export default AttendenceTable;
